export default __webpack_public_path__ + "img/sagoo/sagoo9_700.webp";